import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiBell } from 'react-icons/fi';

interface NotificationsBellProps {
  count: number;
  onClick: () => void;
}

const NotificationsBell = React.forwardRef<HTMLButtonElement, NotificationsBellProps>(({ count, ...props }, ref) => {
  const { t } = useTranslation();
  const displayCount = count > 99 ? '99' : count;

  return (
    <button
      ref={ref}
      title={t('notifications-bell-aria')}
      className={
        'relative inline-flex h-10 w-10 items-center justify-center rounded-full ' +
        'border border-slate-200 bg-white hover:bg-slate-50 focus:outline-none ' +
        'focus:ring-2 focus:ring-gray-100 cursor-pointer'
      }
      onClick={props.onClick}
    >
      <FiBell className="h-5 w-5" />

      {count > 0 && (
        <span
          className="
              absolute -top-1.5 -right-2
              rounded-full bg-yellow-500 text-white
              text-[10px] font-semibold
              h-[20px] min-w-[20px]
              flex items-center justify-center
              shadow
            "
        >
          {displayCount}
        </span>
      )}
    </button>
  );
});

NotificationsBell.displayName = 'NotificationsBell';

export default NotificationsBell;
